import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white text-slate-600 border-t border-slate-200">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="-ml-4 sm:-ml-5 lg:-ml-6 inline-block">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=320,quality=90,format=auto/assets/4ff98460-cf40-4566-82c8-07bb5181a02e/logo_1.png"
                alt="Røjsmose Isolering ApS"
                className="h-20 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Services Column */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-slate-900">Ydelser</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/ydelser/teknisk-isolering" className="hover:text-brand-orange transition-colors">
                  Rør- & ventilationsisolering
                </Link>
              </li>
              <li>
                <Link to="/ydelser/erhvervsisolering" className="hover:text-brand-orange transition-colors">
                  Erhvervsisolering & ventilation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-slate-900">Firmaoplysninger</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-building text-brand-orange mt-1" aria-hidden="true" />
                <div>
                  <p className="font-semibold text-slate-900">Røjsmose Isolering ApS</p>
                  <p className="text-slate-500 text-xs mt-0.5">CVR: 39476231</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-brand-orange mt-1" aria-hidden="true" />
                <p>Jennyvænget 23, 5270 Odense N</p>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-phone text-brand-orange mt-1" aria-hidden="true" />
                <p>
                  Tlf:{' '}
                  <a
                    href="tel:+4542585848"
                    className="hover:text-brand-orange transition-colors whitespace-nowrap font-medium text-slate-900"
                  >
                    42 58 58 48
                  </a>
                </p>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-envelope text-brand-orange mt-1" aria-hidden="true" />
                <p>
                  Email:{' '}
                  <a
                    href="mailto:iso@rojsmose.dk"
                    className="hover:text-brand-orange transition-colors whitespace-nowrap font-medium text-slate-900"
                  >
                    iso@rojsmose.dk
                  </a>
                </p>
              </li>
            </ul>
          </div>

          {/* Navigation Column */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-slate-900">Hurtige links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-brand-orange transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-brand-orange transition-colors">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/projekter" className="hover:text-brand-orange transition-colors">
                  Projekter
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-brand-orange transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 border-t border-slate-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© {currentYear} Røjsmose Isolering ApS. Alle rettigheder forbeholdes.</p>
          <p>
            Udviklet af professionelt dansk webbureau
          </p>
        </div>
      </div>
    </footer>
  );
}
